import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { LocalityCategoryViewControllerDelegate, LocalityCategoryViewController } from "../../Screen/LocalityCategory/LocalityCategoryViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { LocalityCategoryViewModel } from '../../Screen/LocalityCategory/LocalityCategoryViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class LocalityCategoryCoordinator implements IndexCoordinatorDelegate, LocalityCategoryViewControllerDelegate, TableGenericViewControllerDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepcategorialocalidade")
        return (<ProtectedRoute requiredPermissions={['dengue.cat_localidade.*']} path="/:base/dengue/categoria-localidade" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'dengue.cat_localidade.adicionar',
                    edit: 'dengue.cat_localidade.editar',
                    delete: 'dengue.cat_localidade.excluir',
                }}
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Categoria da Localidade"}
            />)
        }} />)
    }

    private routeForm(): JSX.Element {
        var viewModel = new LocalityCategoryViewModel()
        return (<ProtectedRoute requiredPermissions={['dengue.cat_localidade.adicionar', 'dengue.cat_localidade.editar']} path="/:base/dengue/categoria-localidade/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<LocalityCategoryViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepcategorialocalidade") {
            navigation.history.push(`categoria-localidade/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepcategorialocalidade") {
            navigation.history.push(`categoria-localidade/cad/${idSelection}`);
            return;
        }
    }

}